import {ENV} from 'environments/environment';

export interface BannerType {
  type: any;
  link: any;
  id: any;
  url: any;
  width: any;
  height: any;
  position: any;
}

export interface EventType {
  sapCode: any;
  eventName: any;
  label: any;
}

export enum Tabs {
  ONLY_EXHIBITORS = "ONLY_EXHIBITORS",
  ONLY_PRODUCTS = "ONLY_PRODUCTS",
  ONLY_NOVELTIES = "ONLY_NOVELTIES",
  ONLY_BRANDS = "ONLY_BRANDS"
}
export enum Views {
  MODERN = "MODERN",
  GRID = "GRID",
  LIST = "LIST"
}

export interface SearchConfig {
  page: number;
  size: number;
  eventName: string;
  sapCode: string;
  eventCode: string;
  searchText: string;
  brand: string;
  selectedHierarchicalProperties: any[];
  selectedProperties: any[];
  selectedSectors: any[];
  selectedHomeOds: any[];
  selectedCountries: any[];
  selectedMultiEvents: any[];
  filter: string;
  searchOrder: string;
  language: string;
  maxTextLength: number;
  createCache: number;
}


export const CONSTANTS = {
  APP_NAME: "fira.bcn.ptne",
  AVAILABLE_LANGS: ['es', 'ca', 'en'],
  DEFAULT_LANG: 'es',
  DEFAULT_COUNTRY_ID: 209,
  LANG_ES: 'es_ES',
  LANG_CA: 'es_CA',
  LANG_EN: 'en_GB',
  STATES: {
    EVENTS: '/events'
  },
  FAIRGROUNDS: ['GV', 'M1', 'PV', 'WTC'],
  FAIRGROUNDS_WITH_MAP_IMAGE: ['GV', 'M1', 'PV'],
  TRANSLATIONS_BY_DEFAULT_PATH: '/shows/cpa/literals/default/',
  TRANSLATIONS_PATH: '/shows/cpa/literals/',
  VALID_ROLES: ['ROLE_ECATALOGUE_EXHIBITOR', 'ROLE_ECATALOGUE_FIRA_SALES', 'ROLE_ECATALOGUE_FIRA_ADMIN', 'ROLE_ECATALOGUE_FIRA_ADMIN_MASTER', 'ROLE_ECATALOGUE_MULTI_EXHIBITOR', 'ROLE_ECATALOGUE_REGISTERED_USER'],
  END_POINTS: {
    CATALOGUE: {
      GET_PROFILES: '/catalogues',
      GET_HALLS: '/catalogues/home',
      UPDATE_PROPERTIES: '/catalogues',
      GET_ACTIVES: '/catalogues',
      GET_ALL: '/catalogues',
      FIND_BY_EVENT_NAME: '/catalogues/search/findByEventNameOrSapCodeAndEnabledTrue',
      BASE: '/catalogues',
      GET_SOCIAL_NETWORK: '/catalogues',
      GET_HIERARCHICAL_PROPERTIES: '/catalogues',
      GET_COUNTRIES_IN_USE: '/catalogues',
      GET_FILES_BY_CATALOGUE_AND_PRODUCT: '/files',
      GET_SOCIAL_NETWORKS_BY_EVENT: '/catalogues',
      GET_FAVORITE_RESOURCES: '/catalogueUsers/resource',
      PUBLISH_ALL_EXHIBITORS: '/catalogues/',
      UNPUBLISH_ALL_EXHIBITORS: '/catalogues/',
      CREATE_EXHIBITOR: '/catalogues/',
      GET_CATALOGUE_LANGUAGE_PROPERTIES: '/catalogues/',
      CATALOGUE_LANGUAGE_SAVE_AND_UPDATE: '/catalogues/',
      SAVE_FILE: '/catalogues',
      GET_CATALOGUE_MULTI_EVENTS: '/catalogues',
      UPDATE_IMAGES_COLORS_BANNER: '/catalogues',
      TRANSLATIONS: {
        GET_TRANSLATIONS: '/translations/translate',
        CHECK_REDIS: '/translations/redis/check'
      }
    },
    LOGIN: {
      GET_TOKEN: '/login/token',
      GET_USER: '/login/user',
      CHECK_LOGGED_USER: '/catalogueUsers/resource',
      CHECK_ATTENDEE: '/attendee/login',
      LOGOUT: '/catalogues'
    },
    FILTERS: {
      BASE: '/catalogues',
      GET_SECTORS: '/sectors/search/findByCatalogueEventName',
      GET_ODS: '/catalogues/odsProperties/byCatalogueName',
      GET_MASTER_PROPERTIES: '/masterProperties/byCatalogueName',
      GET_HIERARCHICAL_PROPERTIES: '/hierarchicalProperties/byCatalogueName',
      GET_MULTI_EVENTS: '/cataloguesMultiEvents',
      GET_EMAIL_VISITOR: '/email/sendExpositorByVisitor'
    },
    SEARCH: {
      UNIFIED_SEARCH: '/us/unifiedSearch',
      GET_CATALOGUE_EXHIBITOR: '/files/search/byCatalogueAndExhibitor',
      GET_CATALOGUE_PRODUCT: '/files/search/byCatalogueAndProduct'
    },
    DETAILS: {
      GET_DETAILS_JSON: '/details.json',
      GET_CATALOGUE_DETAIL_ID: '/open/catalogues',
      CREATE_CATALOGUE_DETAILS: '/catalogues'
    },
    BRANDS: {
      GET_BRANDS: '/catalogues'
    },
    MAPS: {
      GET_FIRA_MAPS: '/catalogues'
    },
    EXHITORS: {
      GET_PUBLISHED_PRODUCTS: '/exhibitors',
      GET_CATEGORIES: '/exhibitors',
      GET_PROJECTION: '/exhibitors',
      GET_IMAGES: '/exhibitors',
      GET_EXHIBITOR_MAIN_IMAGE_URL: '/exhibitors',
      GET_STATUSES: '/exhibitorStatus',
      GET_PRODUCTS: '/exhibitors',
      SAVE_EXHIBITOR: '/exhibitors/resource',
      GET_EXHIBITOR: '/exhibitors',
      GET_EXHIBITOR_SECTOR: '/exhibitors',
      GET_EXHIBITOR_CATALOGUE_PLAN: '/exhibitors',
      GET_IMPORT_EXHIBITOR: '/exhibitors'
    },
    BANNER: {
      GET_BANNER_RANDOM: '/catalogues'
    },
    ODS: {
      GET_ODS: '/exhibitors',
      GET_ODS_ACTIVE: '/catalogues/'
    },
    PRODUCTS: {
      GET_PRODUCTS_DETAILS: '/products',
      GET_CATEGORIES: '/products',
      GET_PRODUCTS_IMAGES: '/products',
      GET_PRODUCTS_CATEGORIES: '/products',
      GET_HIERARCHICAL_PROPERTIES: '/products',
      SAVE_PRODUCT: '/products/resource',
      UPDATE_PUBLISHED: '/products/updatePublished',
      UPDATE_NOVELTIES: '/products/updateNovelties',
      REMOVE_PRODUCT: '/products/resource',
      UPDATE_PRODUCTS: '/products/updateAll'
    },
    CATALOGUE_USER: {
      CHANGE_LANGUAGE: '/catalogueUsers',
      CHANGE_PASSWORD: '/catalogueUsers/changePasswordUserLogged',
      GET_EXHIBITORS_BY_CATALOGUE_USER_ID: '/catalogueUsers/exhibitors/byCatalogueUserId',
      GET_TOKEN_FORGOT_PASSWORD: '/catalogueUsers/getTokenForgotPassword'
    },
    USERS: {
      RECOVERY_PASSWORD: '/users/recoveryPassword',
      SEND_ONE_TIME_PASSWORD: '/otp/create/and/send/code'
    },
    WELCOME_PACK: {
      GET_CATALOGUE_WELCOME_PACK: '/catalogues',
      GET_WELCOME_BOXES: '/welcomePacks',
      GET_WELCOME_FILES: '/welcomePacks'
    },
    EXHIBITOR_PROFILE: {
      GET_PROFILE: '/catalogues',
      SAVE_PROFILE: '/exhibitors/adminSheet',
      GET_LOGIN_DATA: '/exhibitors/getLoginData'
    },
    CATALOGUE_PLANS: {
      GET_BY_EVENT_NAME: '/cataloguePlans/search/findByCatalogueEventName'
    },
    MEDIA: {
      REORGANIZE: '/images/reorganize',
      ADD_FILE: '/files',
      DELETE_FILE: '/files/resource',
      ECATALOGUE: '/ecatalogue'
    },
    COUNTRIES: {
      GET_COUNTRIES: '/countries?size=999'
    }
  },
  ROLES: {
    EXHIBITOR: 'ROLE_ECATALOGUE_EXHIBITOR',
    SALES: 'ROLE_ECATALOGUE_FIRA_SALES',
    BACKOFFICE: 'ROLE_ECATALOGUE_FIRA_ADMIN',
    SUPERADMIN: 'ROLE_ECATALOGUE_FIRA_ADMIN_MASTER',
    USER: 'ROLE_USER',
    MULTIEXHIBITOR: 'ROLE_ECATALOGUE_MULTI_EXHIBITOR',
    REGISTERED_USER: 'ROLE_ECATALOGUE_REGISTERED_USER'
  }
};

export const REQ = {
  NO_AUTH: [
    ENV.BASE_PATH.USERS + CONSTANTS.END_POINTS.LOGIN.GET_TOKEN,
    ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.CATALOGUE.GET_HALLS,
    ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.CATALOGUE.FIND_BY_EVENT_NAME,
    ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.LOGIN.LOGOUT,
    ENV.BASE_PATH.USERS + CONSTANTS.END_POINTS.USERS.SEND_ONE_TIME_PASSWORD,
    ENV.BASE_PATH.USERS + CONSTANTS.END_POINTS.USERS.RECOVERY_PASSWORD,
    ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.CATALOGUE.GET_PROFILES,
    ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.CATALOGUE.GET_HIERARCHICAL_PROPERTIES,
    ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.FILTERS.GET_SECTORS,
    ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.FILTERS.GET_ODS,
    ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.FILTERS.GET_MASTER_PROPERTIES,
    ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.FILTERS.GET_HIERARCHICAL_PROPERTIES,
    ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.FILTERS.GET_MULTI_EVENTS,
    ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.CATALOGUE.GET_FILES_BY_CATALOGUE_AND_PRODUCT,
    ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.EXHITORS.GET_PUBLISHED_PRODUCTS
  ],
  SHOULD_AUTH: [
    {
    "PARAM":'projection=detail'
    },
    {
    "PARAM":'exhibitorProfiles'
    },
    {
    "PARAM":'exhibitorProfile'
    },
    {
    "PARAM":'exhibitors/resource'
    },
    {
    "PARAM":'welcomePack'
    },
    {
    "PARAM":'files/resource'
    },
    {
    "PARAM":'/exhibitors/'
    },
    {
      "PARAM": 'catalogueLanguageProperties'
    }

  ]
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
